import React from "react";

const TAB_ICONS = {
  dashboard: "📊",
  questions: "📝",
  results: "📋",
};

const AdminLayout = ({
  t,
  activeTab,
  onTabChange,
  onExit,
  error,
  onRetry,
  pageTitle,
  pageSubtitle,
  children,
}) => {
  const tabs = [
    { id: "dashboard", label: t.dashboard },
    { id: "questions", label: t.manageQuestions },
    { id: "results", label: t.viewResults },
  ];

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <img src="/logo.png" alt="HevMed" className="admin-sidebar-logo" />
          <div>
            <p className="admin-sidebar-title">HevMed</p>
            <p className="admin-sidebar-sub">{t.adminPanel}</p>
          </div>
        </div>

        <nav className="admin-sidebar-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`admin-nav-item ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => onTabChange(tab.id)}
            >
              <span className="admin-nav-icon">{TAB_ICONS[tab.id]}</span>
              <span>{tab.label}</span>
              {activeTab === tab.id && <span className="admin-nav-indicator" />}
            </button>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <button type="button" className="admin-nav-item logout" onClick={onExit}>
            <span className="admin-nav-icon">🚪</span>
            <span>{t.logout}</span>
          </button>
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-mobile-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`admin-mobile-tab ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => onTabChange(tab.id)}
            >
              {TAB_ICONS[tab.id]} {tab.label}
            </button>
          ))}
        </div>
        <header className="admin-topbar">
          <div>
            <h1 className="admin-page-title">
              {pageTitle || tabs.find((tab) => tab.id === activeTab)?.label}
            </h1>
            <p className="admin-page-subtitle">
              {pageSubtitle || t.adminWelcome}
            </p>
          </div>
        </header>

        {error && (
          <div className="admin-alert">
            <span className="admin-alert-icon">⚠️</span>
            <span>{error}</span>
            <button type="button" onClick={onRetry} className="admin-alert-btn">
              {t.retry}
            </button>
          </div>
        )}

        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
